import { ref } from '@nuxtjs/composition-api';

export default function useEvents (hubbleClient) {
  const loading = ref(false)
  if (!hubbleClient) {
    throw new Error('You must provide the hubble client from the appContext to use  this composable');
  }
  const publishEvent = async (message = '') => {
    loading.value = true;
    const eventResponse = await hubbleClient.events.publishEvent(message)
    loading.value = false;
    return eventResponse.data;
  }
  return {
    publishEvent,
    loading
  }
}
